<template>
  <div id="layout" class="default" :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }">
    <div class="wrapper">
      <sidebar :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }" />
      <div class="main" :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }">
        <header>
          <top-header />
        </header>
        <section>
          <main class="content p-0" style="position: relative;">
            <router-view />
          </main>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import TopHeader from '@/components/Layout/Header/Header'

export default {
  name: 'LayoutFullMap',
  components: {
    TopHeader
  },
  // computed: {
  //   productPath() {
  //     Vue.component('sidebar', () => import(`@/components/Layout/Sidebar/${this.productPath}/Sidebar`))
  //     return this.ecosystem.product.charAt(0).toUpperCase() + this.ecosystem.product.substr(1).toLowerCase()
  //   }
  // },
  watch: {
    productPath(val) {
      if (val) {
        Vue.component('sidebar', () => import(`@/components/Layout/Sidebar/${this.componentProductPath}/Sidebar`))
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#layout {
  &.default {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    .wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
      height: 100%;
      .main {
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 100vh;
        overflow: hidden;
        padding-left: 160px;
        transition: padding-left .3s ease;
        &.pinned {
          padding-left: 40px;
        }
        &.collapsed {
          padding-left: 0;
        }
        header {
          flex: 0 0 40px;
          border-bottom: 1px solid #eee;
          box-shadow: 0 0 10px rgba(0, 0, 0, .1) !important;
        }
        section {
          flex: 1;
          overflow: hidden;
          .content {
            height: 100%;
            overflow: hidden;
            overflow-y: auto;
          }
        }
        footer {
          flex: 0 0 20px;
          background-color: #C14F4F;
        }
      }
    }
  }
}
</style>
